/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React from 'react';
import { useSelector } from 'react-redux';

const UpdateForm = props => {
  const { handleUpdateCard, index, handleEditCard } = props;
  const todos = useSelector(state => state.todoApp);
  const {
    title, description, tags, editMode,
  } = todos[index];

  return (
    <div>
      <form name="form" className="Form--update" onClick={e => e.stopPropagation()} onSubmit={handleUpdateCard} onKeyDown={e => e.stopPropagation()}>
        <label htmlFor="title" className="Form__titleText">
          Update Title
          <br />
          <input type="text" name="title" className="Form__titleInputUpdate" required placeholder="Title" defaultValue={title} autoComplete="off" />
        </label>
        <label htmlFor="description" className="Form__descriptionText">
          Update Description
          <br />
          <input type="text" name="description" className="Form__descriptionInputUpdate" placeholder="Description" defaultValue={description} autoComplete="off" />
        </label>
        <label htmlFor="tags" className="Form__tagsText">
          Update Tags
          <br />
          <input type="text" name="tags" className="Form__tagsInputUpdate" placeholder="Tags" defaultValue={tags} autoComplete="off" />
        </label>
        <input type="submit" value="Update Todo" className="Form__button" />
        <button type="button" onClick={handleEditCard} className="card__button--editForm">{editMode ? 'Cancel' : 'Edit'}</button>
      </form>
    </div>
  );
};

export default UpdateForm;
